/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'xls': {
    width: 40,
    height: 50,
    viewBox: '0 0 40 50',
    data: '<g stroke-width="2" _stroke="#55595E" stroke-linecap="round" stroke-linejoin="round" _fill="none" fill-rule="evenodd"><path pid="0" d="M0 0h28v12h12v38H0zM28 0l12 12"/></g><g _fill="#4FD249" fill-rule="evenodd"><path pid="1" d="M6 39h8v2H6zM16 39h8v2h-8zM26 39h8v2h-8zM6 33h8v2H6zM16 33h8v2h-8zM26 33h8v2h-8zM6 27h8v2H6zM16 27h8v2h-8zM26 27h8v2h-8zM6 21h8v2H6zM16 21h8v2h-8zM26 21h8v2h-8zM6 15h8v2H6zM16 15h8v2h-8z"/></g>'
  }
})
